import * as Long from "long";
export var selectInventoryInfo = function (state) { return state.inventoryInfo; };
export var selectInventoryResourceInfo = function (state, id) {
    var inventoryInfo = selectInventoryInfo(state);
    var resource = inventoryInfo.resource && inventoryInfo.resource.find(function (res) { return res.typeId === id; });
    return (resource || {
        amount: Long.ZERO,
        stageId: 0,
        typeId: id,
    });
};
export var selectOwnedPicturesId = function (state) {
    return state.inventoryInfo.profilePicture.map(function (picture) { return picture.typeId; });
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectInventoryInfo.ts
// module id = 42
// module chunks = 3